export default __webpack_public_path__ + "locales/sr-Latn-RS/SalesDepartmentRequestDialog.json?hash=c1ce8bf698a524da1e387cec2fec3532";